import React from "react";
import "./index.css";
import cookies from "js-cookie";
import { Row, Col } from "antd";
import { useRedirect } from "pages/hooks/redirect";
import { rightHost } from "components/common";
import { withCompanySetting } from "pages/context/companySetting";

export default withCompanySetting(function HeaderBar({
  companySetting: setting,
  renderLeft,
  renderRight,
  login = false
}) {
  const [redirect, setTo] = useRedirect();
  // console.log('HeaderBar', arguments, redirect)
  return (
    <>
      <header className="spHeadBox">
        <div className="xgHead">
          {redirect}
          <Row>
            <Col span={4}>
              <div className="header-logo">
                <a
                  href={
                    !cookies.get("dingzhiBol") &&
                    rightHost.includes(window.location.hostname)
                      ? "/survey?returns=trues"
                      : ""
                  }
                  style={{ display: "inline-flex", alignItems: "center" }}
                  title="回到首页"
                >
                  {console.log(setting.setting.registBg)}
                  <img
                    src={setting.setting.registBg}
                    alt="logo"
                    className={
                      setting.setting.registBg.indexOf("denglulogo") !== -1
                        ? "logo"
                        : "spLogo"
                    }
                  />
                  {login &&
                    setting.setting.loginBgAppend &&
                    !cookies.get("dingzhiBol") && (
                      <span>
                        <a
                          href="/"
                          style={{
                            position: "relative",
                            // top: 5,
                            marginLeft: 20,
                            fontSize: 12
                          }}
                        >
                          返回首页
                        </a>
                      </span>
                      // <img
                      //   src={setting.setting.loginBgAppend}
                      //   alt="logo"
                      //   className="logo"
                      //   style={{ marginLeft: 20 }}
                      // />
                    )}
                  {/* <p className="com">{setting.loginTitle}</p> */}
                </a>
              </div>
            </Col>
            <Col span={10}>
              {renderLeft && (
                <div className="header-left">
                  {window.location.href.indexOf("/mymymanager") === -1 &&
                    !cookies.get("dingzhiBol") &&
                    !cookies.get("fangBol") && (
                      <a href="/survey?returns=trues">首页</a>
                    )}
                  {renderLeft}
                </div>
              )}
            </Col>
            <Col span={10}>
              <div className="header-right">{renderRight}</div>
            </Col>
          </Row>
        </div>
      </header>
      <div className="head-holder" />
    </>
  );
});
